import { Component, OnInit } from '@angular/core';
import { StorageService } from '../../services/storage.service';
import { UsersService } from '../../services/users.service';
import { Router } from '@angular/router';

declare const $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  session: any;
  minutes: number;

  constructor(
    private readonly storageService: StorageService,
    private readonly router: Router,
    private readonly usersService: UsersService,

  ) { }

  ngOnInit(): void {
    this.session = this.storageService.get('user');
    this.getMinutes();
  }

  async getMinutes(): Promise<void> {
    const response = await this.usersService.getPackageMinutes(this.session.idUsuario);
    this.minutes =  response.data;

    $('[data-toggle="tooltip"]').tooltip();
  }

  hasAuth(module: string): boolean {
    return this.storageService.hasAuth(module);
  }

  logout(): void{
    this.storageService.clear();
    this.router.navigate(['/login']);
  }

}
